import { BaseComponent } from '../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../../components/Buttons';
import { selectConfig, selectWorks } from '../../../../Api/selectors';

import {
  createVehicleWithProps,
  fromAutotelex,
  initiateVehicleCreate,
  setNewVehicle,
  setNewVehicleValue,
  applyAutotelexOptionsToVehicle,
  fetchVehicle,
  initiateVehicleEdit,
  setVehicleProperties,
  generateIncomingInvoice,
} from '../../../../Vehicles/actions';
import { REQUEST_VEHICLE } from '../../../../Vehicles/constants';
import { selectVehicle, selectNewVehicleOptions, selectVehicles, selectNewVehicle } from '../../../../Vehicles/selectors';
import { resetProperties } from '../../../helpers';
import { SelectCreditorModal } from './AddCreditorModal/SelectVehicleCreditorCompany';
import { AddVehicleModalBase } from './VehicleBaseModal/AddVehicleModalBase';
import { getCompanyWorkflows } from '../../../../Companies/actions';
import { addApiError } from '../../../../Api/actions';
import { HBox } from '../../../../../components/Box';
import { fetchInvoice } from '../../../actions';
import { selectInvoice } from '../../../selectors';
import { REQUEST_INVOICE } from '../../../constants';
import { Loader } from '../../../../../components/Loader';



const STATE = {
  isCreditorModal: false,
  isSecondModal: false,
  showAcceptDuplicate: false,
  acceptedForDuplicate: false,
  oldVehicles: null,
};

const INCOMING_TRANSPORT_TYPES = [
  'transport_from_address_id',
  'transport_to_address_id',
  'transport_incoming_from_company_id',
  'transport_incoming_to_company_id',
  'transport_incoming_from_company_name',
  'transport_incoming_to_company_name',
  'transport_direction',
  'transport_is_nl',
  'transport_requested',
];

class InvoiceCreateCopyModalsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.init();
    this.props.fetchInvoice();
    if (this.props.vehicleId) {
      this.props.fetchVehicle(result => {
        if (result?.id) {
          this.props.initVehicleValues();
        }
      });
    }
  }

  get propertyNames() {
    return Object.keys(this.props.values);
  }

  onCreditorModalConfirm() {
    if (
      this.props.values?.creditor_company &&
      (this.props.values?.creditor || this.props?.serverConfig?.incomingContactOptional)
    ) {
      this.setState({ isCreditorModal: false, isSecondModal: true });
      const companyId = this.props.values?.creditor_company;
      this.props.getCompanyWorkflows(companyId, () => {
        this.setState({ isCreditorModal: false, isSecondModal: true });
      });
    }
  }

  reset() {
    // const resetTypes = resetProperties('addModal');
    this.setState({ ...STATE });
    this.props.resetValues(this.propertyNames);
  }

  save(callback, saveStrategy) {
    let properties = [];
    const setIncomingProps =
      this.props.values?.start_incoming_transport == '1' &&
      (this.props.values?.transport == 'pickup' || this.props.values?.transport == 'is_available');

    for (let i in this.props.values) {
      if (i === 'import') {
        properties.push({
          propertyName: i,
          propertyValue: !this.props.values?.regplate?.trim().length ? '1' : this.props.values[i],
        });
      }

      if (i == 'start_incoming_transport_later' && this.props.values[i] == '1') {
        properties.push({
          propertyName: 'incoming_transport_has_to_start',
          propertyValue: '1',
        });
        continue;
      }

      if (INCOMING_TRANSPORT_TYPES.includes(i) && !setIncomingProps) {
        continue;
      }

      if (i === 'wegenbelasting' && this.props?.values[i]?.toLowerCase() == 'onbekend') {
        continue;
      }

      if (i == 'transport_requested') {
        properties.push({
          propertyName: 'transport_requested',
          propertyValue: '1',
        });
        continue;
      }

      if (i == 'transport_direction') {
        properties.push({
          propertyName: 'transport_direction',
          propertyValue: 'incoming',
        });
        continue;
      }

      if (this.props.values[i] != '' && i !== 'import') {
        properties.push({
          propertyName: i,
          propertyValue: this.props.values[i],
        });
      }
    }

    if (this.props.tradeInVehicle) {
      properties.push({
        propertyName: 'trade_in',
        propertyValue: '1',
      });
    }

    return this.props.patch(properties, result => {
      if (result) {
        this.props.generateIncomingInvoice(res => {
          if (res?.success) {
            this.to(`invoices/incoming/${this.props.vehicle.incoming_invoice}`);
          }
        });
      }
    });
  }

  confirmDuplicate = callback => {
    this.setState({ acceptedForDuplicate: true, showAcceptDuplicate: false }, () => {
      callback();
    });
  };

  cancelAcceptDuplicate = () => {
    const resetTypes = resetProperties('addModal');
    this.setState(
      { showAcceptDuplicate: false, acceptedForDuplicate: false, oldVehicles: null },
      this.props.resetValues(this.propertyNames),
    );
  };

  acceptDuplicateBody = () => ({
    cancel: () => this.cancelAcceptDuplicate(),
    confirm: callback => this.confirmDuplicate(callback),
    isVisible: this.state.showAcceptDuplicate,
  });

  handleBack = () => {
    let setNewVehicleData = {
      creditor_company: this.props.values.creditor_company,
    };
    if (this.props.values.creditor) {
      setNewVehicleData.creditor = this.props.values.creditor;
    }
    this.props.setNewVehicle(setNewVehicleData, true);
    this.setState({ isCreditorModal: true, isSecondModal: false });
  };

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <HBox center>
        {this.state.isCreditorModal && (
          <SelectCreditorModal
            copyFromInvoice={this.props.copyFromInvoice}
            reset={this.reset.bind(this)}
            onConfirm={this.onCreditorModalConfirm.bind(this)}
            tradeInVehicle={this.props.tradeInVehicle}
            defaultCreditor={this.props.defaultCreditor}
            defaultCreditorUser={this.props.defaultCreditorUser}
          />
        )}
        {this.state.isSecondModal && (
          <AddVehicleModalBase
            onSave={this.save.bind(this)}
            creditorCompanyId={this.props.values?.creditor_company}
            reset={this.reset.bind(this)}
            acceptCopy={this.acceptDuplicateBody}
            oldVehicles={this.state.oldVehicles}
            tradeInVehicle={this.props.tradeInVehicle}
            back={this.handleBack}
          />
        )}

        {window.innerWidth > 768 && (
          <Button onClick={() => this.setState({ isCreditorModal: true })}>
            {this.lbl('vehicle.overview.copy_invoice')}
          </Button>
        )}
      </HBox>
    );
  }
}

InvoiceCreateCopyModalsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE, `${REQUEST_INVOICE}-${ownProps.copyFromInvoiceId}`]),
    values: selectNewVehicle(),
    newVehicleOptions: selectNewVehicleOptions(),
    allVehicles: selectVehicles(),
    serverConfig: selectConfig(),
    copyFromInvoice: selectInvoice(ownProps.copyFromInvoiceId),
    vehicle: selectVehicle(ownProps.vehicleId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateVehicleCreate());
    },
    create(properties, options, callback) {
      dispatch(createVehicleWithProps(properties, options, callback));
    },
    resetValues(values, name = null) {
      values.map(type => dispatch(setNewVehicleValue(type, '')));
    },
    fetchFromAutotelex(vehicle_id, regplate, callback) {
      dispatch(fromAutotelex(vehicle_id, regplate, callback));
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps?.vehicleId, props, callback));
    },
    generateIncomingInvoice(callback) {
      dispatch(
        generateIncomingInvoice(ownProps?.vehicleId, callback, {
          copyProductSubjectsFrom: ownProps?.copyFromInvoiceId,
        }),
      );
    },
    fetchInvoice() {
      dispatch(fetchInvoice(ownProps?.copyFromInvoiceId, () => {}, { copyFromInvoiceId: ownProps?.copyFromInvoiceId }));
    },

    fetchVehicle(callback) {
      dispatch(fetchVehicle(ownProps?.vehicleId, callback));
    },
    initVehicleValues() {
      dispatch(initiateVehicleEdit(ownProps?.vehicleId));
    },
    setNewVehicle(data, reset) {
      dispatch(setNewVehicle(data, reset));
    },
    setNewVehicleValue(name, value) {
      dispatch(setNewVehicleValue());
    },
    getCompanyWorkflows(companyId) {
      dispatch(getCompanyWorkflows(companyId));
    },
    applyNewVehicleOptions(vehicleId, regplate, callback) {
      dispatch(applyAutotelexOptionsToVehicle(vehicleId, regplate, callback));
    },
    addApiError(msg) {
      dispatch(addApiError(msg));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceCreateCopyModals = compose(withConnect, withRouter)(InvoiceCreateCopyModalsComp);
